import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
    getActionDescriptionModelType,
    useActionBlockFormProps
} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";
import {
    OnlineChatAiChoiceActionDescription,
} from "~/cabinet/ts/data/events/ActionDescription";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";
import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import {
    OnlienChatAiChoiceCriteriaInterface,
    OnlineChatAiChoiceParamInterface
} from "~/cabinet/vue/client/events/action/types/Interface";
import MyInputList from "~/cabinet/vue/interface/form/MyInputList.vue";


const __default__ = {
    name: "OnlineChatAiChoiceBlockForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useActionBlockFormProps<OnlineChatAiChoiceActionDescription>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props;

let _modelValue = _useModel<getActionDescriptionModelType<OnlineChatAiChoiceActionDescription>>(__props, "modelValue");
let model = useObjectModel<OnlineChatAiChoiceParamInterface>(_modelValue, () => {
    return {
        subject: "",
        instructions: "",
        criteria: []
    }
});

function newCriteria(): OnlienChatAiChoiceCriteriaInterface {
    return {
        id: "",
        descr: ""
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, {
      rules: _unref(requiredRule),
      label: "Текст для анализа"
    }, {
      default: _withCtx(() => [
        _createVNode(TextInputWithVariables, {
          modelValue: _unref(model).subject,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).subject) = $event)),
          "content-variables": _unref(props).contentVariables,
          multiline: false
        }, null, 8, ["modelValue", "content-variables"])
      ]),
      _: 1
    }, 8, ["rules"]),
    _createVNode(_component_el_form_item, {
      rules: _unref(requiredRule),
      label: "Вопрос для нейро-сети"
    }, {
      default: _withCtx(() => [
        _createVNode(TextInputWithVariables, {
          modelValue: _unref(model).instructions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).instructions) = $event)),
          "content-variables": _unref(props).contentVariables,
          multiline: false
        }, null, 8, ["modelValue", "content-variables"])
      ]),
      _: 1
    }, 8, ["rules"]),
    _createVNode(_component_el_form_item, {
      rules: _unref(requiredRule),
      label: "Варианты ответа"
    }, {
      default: _withCtx(() => [
        _createVNode(MyInputList, {
          modelValue: _unref(model).criteria,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).criteria) = $event)),
          "new-item-value-getter": newCriteria
        }, {
          default: _withCtx(({index}) => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createElementVNode("p", null, "Вариант ответа:", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _unref(model).criteria[index].id,
                  "onUpdate:modelValue": ($event: any) => ((_unref(model).criteria[index].id) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _cache[4] || (_cache[4] = _createElementVNode("p", null, "Когда он должен быть выбран:", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _unref(model).criteria[index].descr,
                  "onUpdate:modelValue": ($event: any) => ((_unref(model).criteria[index].descr) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["rules"])
  ]))
}
}

})